// =====================================================================
// PLENARIUM:HOMOLOGACAO -- botoes de dados de teste. So aparecem na
// camara de homologacao (o servidor confere; nas outras nao aparecem).
//  - BotaoMateriasTeste: 10 materias com anexos no Tramite (com sessaoId,
//    ja entram na pauta da sessao)
//  - BotaoExpedienteTeste: 5 avisos, 5 convites e 5 oficios no Expediente
// =====================================================================
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Zap } from 'lucide-react';

let cache = null;
function useHomologacao() {
  const [ativa, setAtiva] = useState(cache === true);
  useEffect(() => {
    let vivo = true;
    if (cache !== null) { setAtiva(cache); return undefined; }
    axios.get('/api/homologacao/ativa').then(r => { cache = !!(r.data && r.data.ativa); if (vivo) setAtiva(cache); }).catch(() => { cache = false; });
    return () => { vivo = false; };
  }, []);
  return ativa;
}

const estilo = { display: 'inline-flex', alignItems: 'center', gap: 6, background: '#fff7ed', color: '#9a3412', border: '1px dashed #fb923c', borderRadius: 10, padding: '7px 12px', fontWeight: 700, fontSize: '.8rem', cursor: 'pointer' };

export function BotaoMateriasTeste({ sessaoId, onFeito }) {
  const ativa = useHomologacao();
  const [ocupado, setOcupado] = useState(false);
  if (!ativa) return null;
  const gerar = async () => {
    if (!window.confirm(sessaoId ? 'Gerar 10 matérias de teste (com anexos) no Trâmite e colocar na pauta desta sessão?' : 'Gerar 10 matérias de teste com anexos no Trâmite?')) return;
    setOcupado(true);
    try {
      const r = await axios.post('/api/homologacao/materias', sessaoId ? { sessaoId } : {});
      toast.success(`${r.data.criadas} matérias criadas, ${r.data.anexos} anexos${sessaoId ? `, ${r.data.naPauta} na pauta` : ''}.`);
      if (onFeito) onFeito();
    } catch (e) { toast.error((e.response && e.response.data && e.response.data.error) || 'Não foi possível gerar.'); }
    finally { setOcupado(false); }
  };
  return (
    <button type="button" style={{ ...estilo, opacity: ocupado ? .6 : 1 }} disabled={ocupado} onClick={gerar} title="Só na câmara de homologação">
      <Zap size={14} /> {ocupado ? 'Gerando...' : sessaoId ? 'Teste: 10 matérias na pauta' : 'Teste: gerar 10 matérias'}
    </button>
  );
}

export function BotaoExpedienteTeste({ sessaoId }) {
  const ativa = useHomologacao();
  const [ocupado, setOcupado] = useState(false);
  if (!ativa || !sessaoId) return null;
  const gerar = async () => {
    if (!window.confirm('Gerar 5 avisos, 5 convites e 5 ofícios de teste no Expediente desta sessão?')) return;
    setOcupado(true);
    try { const r = await axios.post(`/api/homologacao/expediente/${sessaoId}`); toast.success(`${r.data.criados} itens criados no Expediente.`); }
    catch (e) { toast.error((e.response && e.response.data && e.response.data.error) || 'Não foi possível gerar.'); }
    finally { setOcupado(false); }
  };
  return (
    <div style={{ margin: '-12px 0 18px' }}>
      <button type="button" style={{ ...estilo, opacity: ocupado ? .6 : 1 }} disabled={ocupado} onClick={gerar} title="Só na câmara de homologação">
        <Zap size={14} /> {ocupado ? 'Gerando...' : 'Teste: 5 avisos, 5 convites e 5 ofícios'}
      </button>
    </div>
  );
}
